<template>
    <div class="product">
        <Menu></Menu>
        <Tabber :tabberData="tabberData" :activeIndex="activeIndex" :tabTitle="tabTitle" @changeTabber="changeTabber">
            <div slot="tabberContent" ref="tabberContent">
            </div>
        </Tabber>
    </div>
</template>
<script>
import { productList,listProductType } from "@/api/manage";
import Menu from '../../components/menu/menu.vue'
import Tabber from '../../components/menu/tabber.vue'
export default {
    components: { Menu, Tabber},
    data () {
        return {
            tabberData: [ ],
            activeIndex: '1',
            tabTitle: '产品体系',
            listData: {},
            data:[],
            id:''
        }
    },
    watch:{
        $route(to,from){
            this.activeIndex = to.params.id
            this.setInfo(this.activeIndex)
            window.scrollTo(0, 0);
        }
    },
    async created(){
       let res = await productList({pageNo:1,pageSize:999})
       let res1 = await listProductType({ pageNo: 1, pageSize: 999, sortType: "a" })
       this.data=res.data
       console.log('this.data',this.data);
             res1.data.map(item=>{
                 let obj ={}
                 obj.id=item.id
                 obj.name=item.typeName
                 this.tabberData.push(obj)
             })
             this.setInfo(this.$route.params.id)
    },
    mounted () {
        window.scrollTo(0,0);
        this.activeIndex = this.$route.params.id
    },
    methods: {
        changeTabber (index) {
            this.$router.push({name: 'product', params: {id: index}})
            this.listData = {}
        },
        async setInfo(index){
             this.$refs["tabberContent"].innerHTML=''
            this.data.map(item=>{
                if(item.type==index){
                    let replaceTxt = 'http://116.206.94.117:8195//uploading'
                    let newTxt = 'http://101.89.182.189:8191//uploading'
                    let text =decodeURI(item.text).replace(new RegExp(replaceTxt,'g'),newTxt)
                  this.$refs[
            "tabberContent"
          ].innerHTML += `<h2 style="text-align:center;font-size:1.145833rem;margin-bottom:1.458333rem">${item.title}</h2>`;
          this.$refs["tabberContent"].innerHTML += text+`<br/><br/><br/><br/>`;
                }
            })
        }
    }
}
</script>
<style scoped>
    .title{
        font-size: 20px;
        color: #333;
        text-align: center;
    }
    .sketchTitle,.featureTitle{
        font-size: 18px;
        color: #666;
        padding-bottom: 10px;
        font-weight: bold;
    }
    .sketchContent,.feature p{
        font-size: 14px;
        color: #666;
        line-height: 28px;
        margin-bottom: 0;
    }
    .sketchContent{
        text-indent: 2em;
    }
    .sketchImg{
        margin: 60px  0;
        text-align: center;
    }
    .sketchImg img{
        height: 380px;
        width: auto;
    }
</style>